import { MerchantStats, ReviewStats } from '@sdk/shared/types/order.types';

export const formatTimeMilliseconds = (milliseconds: number): string => {
  const seconds = Math.floor(milliseconds / 1000);

  if (seconds < 60) {
    return `${seconds} secs`;
  } else if (seconds < 3600) {
    const mins = Math.floor(seconds / 60);
    return `${mins} ${mins === 1 ? 'min' : 'mins'}`;
  } else {
    const hours = Math.floor(seconds / 3600);
    return `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;
  }
};

export interface ProcessedMerchantStats {
  totalOrders: number;
  completionRate: string;
  avgReleaseTime: string;
  avgPayTime: string;
  username: string | null;
  address?: string;
  positiveRates: number;
}

export const processMerchantStats = (stats: MerchantStats): ProcessedMerchantStats => {
  const completionRate = ((stats.released.total / stats.totalOrders || 0) * 100).toFixed(2) || '0';
  const avgReleaseTime =
    stats.released.total > 0
      ? formatTimeMilliseconds(stats.released.time / stats.released.total || 0)
      : '0';
  const avgPayTime =
    stats.paid.total > 0 ? formatTimeMilliseconds(stats.paid.time / stats.paid.total || 0) : '0';

  return {
    totalOrders: stats.totalOrders,
    completionRate: `${completionRate}%`,
    avgReleaseTime,
    avgPayTime,
    username: stats.username,
    address: stats.address,
    positiveRates: stats.positiveRates || 0,
  };
};

export interface ReviewCounts {
  positive: number;
  negative: number;
  total: number;
  positiveRate: number;
}

export const processReviews = (reviews: ReviewStats[]): ReviewCounts => {
  const counts = reviews.reduce(
    (acc, review) => {
      if (review.score === 1) {
        acc.positive += review._count.score;
      } else {
        acc.negative += review._count.score;
      }
      return acc;
    },
    { positive: 0, negative: 0 },
  );

  const total = counts.positive + counts.negative;
  return {
    ...counts,
    total,
    positiveRate: total > 0 ? Number(((counts.positive / total) * 100).toFixed(2)) : 0,
  };
};

export const processPreCountedReviews = (reviews: {
  positive: number;
  negative: number;
  total: number;
}): ReviewCounts => {
  return {
    positive: reviews.positive,
    negative: reviews.negative,
    total: reviews.total,
    positiveRate:
      reviews.total > 0 ? Number(((reviews.positive / reviews.total) * 100).toFixed(2)) : 0,
  };
};
